import { render, staticRenderFns } from "./CustomerTypeAdd.vue?vue&type=template&id=2fe03508&"
import script from "./CustomerTypeAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerTypeAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTypeAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports